import { IBericht } from '@/model/IBericht';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { filter, find } from 'lodash';

@Component
export default class AppUnreadBerichtenBadgeComponent extends Vue {
  @State(state => state.berichten)
  public berichten!: IBericht[];

  get count() {
    return filter(this.berichten || [], b => !b.gelezen || !!find(b.documenten || [], d => !d.gelezen)).length;
  }

  get showBadge(): boolean {
    return this.count > 0;
  }
}
